<template>
  <div style="margin-top: 20px">
    <div ref="chartContainer" style="width: 100%; height: 600px;;margin-bottom: 50px" />
  </div>
</template>
<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'GrantEchart',
  props: {
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#6495ED'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '发放明细'
        },
        xAxis: {
          name: '类型',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          bottom: 0, // 图例在图表的底部
          type: 'scroll'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: 150,
          containLabel: true
        },
        yAxis: [
          {
            type: 'value',
            name: '总计'
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'axis',
          position: function(point) {
            const x = point[0]
            const y = '5%'// 向下移动 20 像素
            return [x, y]
          },
          formatter: function(params) {
            var tooltipContent = ''
            params.forEach(function(item) {
              if (item.value > 0) {
                tooltipContent += item.seriesName + ' : ' + item.value + '<br/>'
              }
            })
            return tooltipContent
          }
        },
        series: []
      }
      this.chart.setOption(this.option)
    },
    init(type, data, maxLevel) {
      this.initChart()
      this.option.xAxis.data = []
      this.option.series = []
      this.option.legend.data = []
      const lenged = []
      const date = []

      data.forEach((item, index) => {
        if (index === 0) {
          for (const i in item.level_data) {
            lenged.push('等级' + i)
          }
        }

        date.push(dateStrTodate(item.date))
      })

      const weekData = {}
      for (let i = 1; i <= maxLevel; i++) {
        weekData[i] = []
      }
      for (const i in data) {
        const val = data[i]
        for (const k in val.level_data) {
          if (weekData[k]) {
            weekData[k].push(val.level_data[k])
          }
        }
      }

      for (const i in weekData) {
        const val = weekData[i]
        const temp = {
          name: '等级' + i,
          type: 'line',
          data: val,
          barWidth: '50%'
        }
        this.option.series.push(temp)
      }

      this.option.xAxis.data = date
      this.option.legend.data = lenged
      this.chart.setOption(this.option, true)
    }
  }
}
</script>

<style scoped>

</style>
